import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateService } from 'api/Service';

import NewServiceModal from 'components/practice/Settings/components/Services/components/NewServiceModal/NewServiceModal';

import { getServiceChanges } from '../lib/helpers';

const EditServiceModal = (props) => {
  const navigate = useNavigate();
  const { id: practiceId } = useParams();
  const queryClient = useQueryClient();

  const { mutateAsync: updateServiceHandler, isLoading } = useMutation({
    mutationFn: (params) => updateService(navigate, params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['services'] });
    }
  });

  const onSave = async (updatedService) => {
    const changes = getServiceChanges(updatedService, props.item);
    if (Object.keys(changes).length > 0) {
      await updateServiceHandler({
        service_id: props.item.id,
        practice_id: Number(practiceId),
        fields: changes
      });
    }
    props.handleClose();
  };

  return (
    <NewServiceModal
      service={props.item}
      isOpen={props.isOpen}
      isLoading={isLoading}
      onClose={props.handleClose}
      onSave={onSave}
    />
  );
};

export default EditServiceModal;
